<template>
	<div class="NewRespondents" v-if="selectedStudy && currentTab">
		<v-alert
			class="respondents-alert"
			v-model="uploadSuccess"
			dismissible
			type="success"
		>
			File Upload Was Successful
		</v-alert>
		<v-alert
			class="respondents-alert"
			v-model="uploadError"
			dismissible
			type="error"
		>
			Error While Uploading File
		</v-alert>
		<v-row
      class="mb-6"
      no-gutters
    >
			<!-- <v-col
				:cols="8"
				v-if="selectedStudy.recordStudyType"
			>
			<div class="left-respondents-column">
				<h2 class="left-align">Add New Respondents</h2>
				<br>
				<p class="p2 left-align">
					Upload your own template file. With this option, you define your respondent accounts.
					Once you have created respondent accounts, you can modify the template file to add dates or accounts.
				</p>
				<v-btn class="btn-default" text @click="uploadDialog = true">
					Upload Template File (.csv)
				</v-btn>
			</div>
			</v-col> -->
      <v-col
        :cols="8"
      >
			<div class="left-respondents-column">
			<div class="d-sr-only-focusable float-right text-decoration-underline" tabindex="0" @keyup.enter="focusToTop" @click="focusToTop" ref="firstFocusable" role="link">Go to top of page</div>
				<h2 class="left-align">Add New Respondents</h2>
				<p class="p2 left-align">There are two ways to create new respondent accounts:</p>
				<h3 class="text-subtitle-2 p2 left-align">
					<strong>OPTION 1.</strong> Use the wizard to guide you through configuration steps. For a
					scheduled study, where respondents will access ASA24 on specific dates, the wizard can randomly
					distribute respondents across all days of the week. You can specify the number of weekday vs. weekend
					recalls per respondent, and the number of days between recalls.
				</h3>
				<br>
				<div class="text-subtitle-2 p2 left-align">
					If you're not sure how to create a scheduled study with the wizard, start with a suggested scheduled study configuration. You can then customize the settings to suit your needs: <a  href="SuggestedScheduledStudyConfigurations-FINAL.pdf" download>ASA24 Suggested Scheduled Study Configurations [pdf]</a>
				</div>
				<br>
				<p class="p2 left-align last-paragraph" id="last-respondent-paragraph-1">
					The wizard is most helpful if
					<ul>
						<li>You are using ASA24 as a recall.</li>
						<li>You have a scheduled study and are unsure how to specify the dietary assessment days for your respondents.</li>
						<li>You have an unscheduled study and are unfamiliar working with .csv files or unsure how to set up your respondent accounts manually.</li>
					</ul>
				</p>
				<v-btn class="btn-default" text @click="goToWizard()" >
					Launch Respondents Wizard
				</v-btn>
				<v-divider inset id="middle-divider"></v-divider>
				<!-- <br> -->
				<h3 class="text-subtitle-2 p2 left-align">
					<strong>OPTION 2.</strong> For more control, upload your own template file. With this option,
					you define your respondent accounts, and for a scheduled study, specify their intake dates.
					Once you have created respondent accounts, you can modify the template file to add dates or accounts.
				</h3>
				<br>
				<div class="text-subtitle-2 p2 left-align">
					Download the import file here: <a href="ImportFile_Template.Jun.2024.final.xlsx" download>Import File CSV</a>
				</div>
				<br>
				<p class="p2 left-align" id="last-respondent-paragraph-2">

					It is best to use the upload file option if
					<ul>
						<li>You have a scheduled study and you have predetermined intake dates you want to assign to each of your respondents.</li>
						<li>You want to modify or add intake dates to an already created scheduled study.</li>
						<li>You have a particular password format you want to use for all your respondents.</li>
					</ul>

				</p>
				<v-btn class="btn-default" text @click="uploadDialog = true">
					Upload Import File (.csv)
				</v-btn>
			</div>
			</v-col>
			<v-col
        :cols="4"
      >
				<div class="help-new-respondents">
					<h3>Help on Adding New Respondents</h3>
					<div class="new-respondent-text">
						<p class="p3 left-align"> For Recall studies, the study type (Scheduled or Unscheduled) and the Intake Time Frame cannot be
							changed once at least one respondent account is created and a recall is started. To change these study
							details, all Respondent Accounts must be deleted.
						</p>
					</div>
				</div>
			</v-col>
		</v-row>
		<foe-dialog
      v-model="uploadDialog"
			:dialogW="uploadDialog"
      persistent
			max-width="600px"
			class="upload-dialog"
    >
      <v-card class="upload-card" v-cloak @drop.prevent="addDropFile" @dragover.prevent>
        <v-card-title>Upload Import File</v-card-title>
        <v-card-text>
					<p class="p3 left-align">Click below to select file to upload or drag and drop in this box to upload file.</p>
					<v-form
						ref="formUpload"
						v-model="validUpload"
						lazy-validation
					>
						<v-file-input
							accept=".csv"
							label="Click to select file"
							v-model="uploadedFile"
							:rules="uploadRules"
						></v-file-input>
					</v-form>
				</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
					<v-btn
            text
						class="btn-default"
            @click="onCancelUpload"
          >
            Cancel
          </v-btn>
          <v-btn
            text
						class="btn-default"
            @click="uploadTemplate()"
						:loading="isUploading"
          >
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </foe-dialog>
	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService.js';
import { utilityService } from '@/services/utilityService.js';
export default {
	name: 'NewRespondents',
	props: {
	},
	data: () => ({
		uploadDialog: false,
		uploadedFile: null,
		validUpload: true,
		uploadRules: [v => v != null || 'A file is required'],
		uploadSuccess: false,
		uploadError: false,
		isUploading: false
	}),
	mounted () {
		// const tabPosition = {
		// 	tabIndex: parseInt(this.$store.getters.getCurrentStudyTabIndex),
		// 	subTabIndex: parseInt(this.$store.getters.getCurrentStudySubTabIndex)
		// };
		// this.checkTabMatch(tabPosition);
	},
	methods: {
		goToWizard () {
			this.$router.push('/study/respondent_wizard');
		},
		uploadTemplate () {
			if (this.$refs.formUpload.validate()) {
				this.isUploading = true;
				const me = this;
				researcherApiService.createRespondentsFromFile(this.uploadedFile, this.selectedStudy.studyUuid)
					.then(function (response) {
						if (response) {
							// Clean up the button states
							me.uploadDialog = false;
							me.uploadError = false;
							me.uploadSuccess = true;
							me.uploadedFile = null;
							me.isUploading = false;

							// Route the user to a success page with links to download the file(s)
							me.$router.push({
								name: 'ConfirmationPage',
								params: {
									fileNameRespondents: response.data.fileNameRespondents,
									fileNameSchedule: response.data.fileNameSchedule
								}
							});
						}
					})
					.catch(function (e) {
						console.log(e);
						me.uploadDialog = false;
						me.uploadError = true;
						me.uploadSuccess = false;
						me.uploadedFile = null;
						me.isUploading = false;
					});
			}
		},
		addDropFile (e) {
			this.uploadedFile = e.dataTransfer.files[0];
		},
		onCancelUpload () {
			this.uploadDialog = false;
			this.uploadedFile = null;
			this.$refs.formUpload.resetValidation();
		},
		async checkTabMatch ({ tabIndex, subTabIndex } = {}) {
			const me = this
			const tabsPos = await utilityService.getTabsPositionByName('Add New Respondents', this.$studyTabConfig);
			if (tabsPos.tabPos === tabIndex && tabsPos.subtabPos === subTabIndex) {
				var myFirstElement = me.$refs.firstFocusable
				setTimeout(() => {
					myFirstElement.focus();
				}, '350');
			}
		},
		focusToTop () {
			var myHeader = document.getElementById('skipToMain')
			myHeader.focus()
		}
	},
	computed: {
		selectedStudy: function () {
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			return this.$store.getters.getSelectedStudy;
		},
		currentTab: function () {
			const tabPosition = {
				tabIndex: parseInt(this.$store.getters.getCurrentStudyTabIndex),
				subTabIndex: parseInt(this.$store.getters.getCurrentStudySubTabIndex)
			};
			this.checkTabMatch(tabPosition);

			return tabPosition;
		}
	}
}
</script>

<style>
#last-respondent-paragraph-1 {
	margin-bottom: 0px;
}
#last-respondent-paragraph-2 {
	margin-bottom: 0px;
}
#middle-divider {
	margin-top: 10px;
	margin-bottom: 20px;
}
</style>
